import _ from 'lodash';

const state = {
  searchState: null,
};

const actions = {
  // SearchReset resets the search state.
  SearchReset({ commit }) {
    commit('RESET_SEARCH_STATE');
  },

  // StoreSearchState commits a search state to the store by deep copying
  // the search state.
  StoreSearchState({ commit }, searchState) {
    commit('SET_SEARCH_STATE', _.cloneDeep(searchState));
  },
};

const mutations = {
  // RESET_SEARCH_STATE resets the search state.
  RESET_SEARCH_STATE(stateArg) {
    const stateCopy = stateArg;
    stateCopy.searchState = null;
  },

  // SET_SEARCH_STATE sets the search state.
  SET_SEARCH_STATE(stateArg, searchState) {
    const stateCopy = stateArg;
    stateCopy.searchState = searchState;
  },
};

export default { actions, mutations, state };
